import { defineComponent as _defineComponent } from 'vue'
import { CompanyTagFormData, useTagComposable } from '@/composables/useTag';
import { ref, watch } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTagDeleteDialog',
  props: {
    value: { type: Boolean },
    selectedTag: null
  },
  emits: ["input", "deleted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'deleted'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean; // Dialog open/close
  selectedTag?: CompanyTagFormData;
};

const m = defineMessages({
  confirmDeleteTag: 'タグを削除しますか?',
});





// for Dialog control
const localValue = ref(props.value);
watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);
const closeDialog = () => {
  emit('input', false);
};

const { deleteCompanyTag } = useTagComposable();
const handleDeleteClick = async () => {
  if (!props.selectedTag?.id) {
    return;
  }
  await deleteCompanyTag(props.selectedTag?.id);
  emit('deleted');
  closeDialog();
};

return { __sfc: true,m, props, emit, localValue, closeDialog, deleteCompanyTag, handleDeleteClick, sharedMessages }
}

})